import type { HTMLAttributes } from 'react';
import { cn } from './cn';

/** Keyboard key, e.g. `<Kbd>Esc</Kbd>`. */
export const Kbd = ({ className, ...props }: HTMLAttributes<HTMLElement>) => (
  <kbd
    className={cn(
      'inline-flex h-5 min-w-5 items-center justify-center rounded border border-border-strong bg-surface-sunken px-1 font-sans text-[11px] font-medium text-fg-muted shadow-[inset_0_-1px_0_rgb(var(--color-border-strong))]',
      className
    )}
    {...props}
  />
);
